import React from 'react';

interface DetailsTopProps {
  title?: string;
  description?: string | React.ReactNode;
  status?: React.ReactNode;
}

const DetailsTop: React.FC<DetailsTopProps> = ({
  title,
  status,
  description,
}) => (
  <>
    {title && (
      <div className="details__top">
        <h2 className="text-2 details__title">{title}</h2>
      </div>
    )}
    {description && (
      <div className="details__info">
        <p className="title-4">{description}</p>
      </div>
    )}
    {status && <div className="details__status">{status}</div>}
  </>
);

export default DetailsTop;
